"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDoctorAttendingByDoctorApiResponseSchema = void 0;
const zod_1 = require("zod");
const api_1 = require("../global/api");
const profile_schema_1 = require("../global/profile.schema");
const doctor_attending_1 = require("./doctor-attending");
exports.createDoctorAttendingByDoctorApiResponseSchema = zod_1.z.object({
    data: zod_1.z.object({
        id: zod_1.z.string().uuid(),
        type: (0, api_1.apiEntityTypeSchema)('doctor-attendings'),
        attributes: zod_1.z.object({
            firstname: zod_1.z.string(),
            lastname: zod_1.z.string(),
            orderRegistrationNumber: zod_1.z.string(),
            iban: zod_1.z.string(),
            bic: zod_1.z.string().nullable().default(null),
            signatureUrl: profile_schema_1.signatureUrlSchema,
            workSchedulesDateRef: zod_1.z.string().nullable(),
            workSchedules: doctor_attending_1.workSchedulesSchema,
            createdAt: zod_1.z.coerce.date(),
            activatedAt: zod_1.z.coerce.date().nullable(),
            deactivatedAt: zod_1.z.coerce.date().nullable().default(null),
        }),
    }),
});
